import { BaseIdentifiers, DeletedIdentifier } from '../../common/identifiers';
import { IconsNames } from '../../icons';
import { ValueOf } from '../../utils';
import { AffiliateRequest } from '../affiliate-request/affiliate-request';

export enum AffiliateUserType {
  Affiliate = 'affiliate',
  Influencer = 'influencer',
  Educator = 'educator',
}

export const AffiliateSocialMediaPlatform = {
  [IconsNames.Facebook]: IconsNames.Facebook,
  [IconsNames.Instagram]: IconsNames.Instagram,
  [IconsNames.Discord]: IconsNames.Discord,
  [IconsNames.Linkedin]: IconsNames.Linkedin,
  [IconsNames.Youtube]: IconsNames.Youtube,
  [IconsNames.Tiktok]: IconsNames.Tiktok,
  [IconsNames.Twitter]: IconsNames.Twitter,
  [IconsNames.Link]: IconsNames.Link, // If didn't match any other platform
} as const;

export type AffiliateSocialMediaProfile = {
  platform: ValueOf<typeof AffiliateSocialMediaPlatform>;
  link: string;
};

export type AffiliateEntity = BaseIdentifiers &
  DeletedIdentifier & {
    id: number;
    type: AffiliateUserType;
    socialMediaProfiles?: AffiliateSocialMediaProfile[];
    requests?: AffiliateRequest[];
    pendingRequest?: boolean;
    groupName?: string;
    couponCode?: string;
    isSplitActive?: boolean;
  };

export type AffiliateUpdateDto = {
  type?: AffiliateUserType;
  socialMediaProfiles?: AffiliateSocialMediaProfile[];
  groupName?: string;
  couponCode?: string;
  isSplitActive?: boolean;
};
